import * as React from "react";
import { Loader } from "semantic-ui-react";
import { useMemo } from "react";
import { StyledDataLoader } from "./DataLoaderStyles";
export function DataLoader(props) {
    var data = props.data, errorMessage = props.errorMessage, isInModal = props.isInModal, children = props.children;
    var isFetching = useMemo(function () {
        return data.some(function (datum) { return datum.isFetching; });
    }, [data]);
    var isReady = useMemo(function () {
        return data.every(function (datum) { return datum.isReady; });
    }, [data]);
    var isError = useMemo(function () {
        return data.some(function (datum) { return datum.isError; });
    }, [data]);
    var errorText = useMemo(function () {
        if (errorMessage !== undefined) {
            return React.createElement("div", null, errorMessage);
        }
        var dataErrors = data
            .map(function (d) { return d.errorMessage; })
            .filter(function (error) { return error !== undefined; });
        if (dataErrors.length !== 0) {
            return dataErrors.map(function (error) { return React.createElement("div", null, error); });
        }
        return React.createElement("div", null, "Something went wrong");
    }, [data, errorMessage]);
    return (React.createElement(React.Fragment, null, isFetching ? (React.createElement(StyledDataLoader, { role: "progressbar", isInModal: isInModal },
        React.createElement(Loader, { active: isFetching, inline: "centered" }))) : isReady ? (React.createElement(React.Fragment, null, children)) : isError ? (errorText) : null));
}
